import { render, staticRenderFns } from "./postInstagram.vue?vue&type=template&id=720f8ea8&"
import script from "./postInstagram.vue?vue&type=script&lang=js&"
export * from "./postInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports